var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "trbo-a-no-products" }, [
    _c("div", { staticClass: "trbo-a-no-products__text" }, [
      _c("p", { staticClass: "trbo-a-no-products__text__description" }, [
        _vm._v(_vm._s(_vm.$t("wizard.noRecommendationDescription"))),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "trbo-a-no-products__text__description" }, [
        _c("em", [
          _vm._v(_vm._s(_vm.$t("wizard.noRecommendationDescription2"))),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "trbo-a-no-products__action" }, [
      _c(
        "button",
        {
          staticClass: "trbo-a-question-next-button",
          on: {
            click: function ($event) {
              return _vm.$emit("restart")
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "trbo-a-question-next-button__wrapper" },
            [
              _c("icon", {
                staticClass: "trbo-a-question-next-button__icon",
                attrs: { name: "next" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "trbo-a-question-next-button__title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t("wizard.noRecommendationRestartButtonTitle")
                    ) +
                    "\n        "
                ),
              ]),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }